'use client';

import { useEffect } from 'react';

export function ForceLightTheme() {
  useEffect(() => {
    const html = document.documentElement;
    const hadDark = html.classList.contains('dark');
    const prevColorScheme = html.style.colorScheme;

    html.classList.remove('dark');
    html.classList.add('light');
    html.style.colorScheme = 'light';

    return () => {
      html.classList.remove('light');
      if (hadDark) html.classList.add('dark');
      html.style.colorScheme = prevColorScheme;
    };
  }, []);

  return null;
}
